import Emitter from "./Emitter";

export default class Error extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler(msg) {
        const data = msg ? { event: "genericError", data: msg.data } : { event: "genericError" };
        this.emitParent(data);
    }

    SPINGAMES_handler() {
        this.emitTop({ event: "error" });
        this.emitParent({ event: "error" });
    }

    POKERSTARS_handler(msg) {
        var dataForXc = undefined;

        if (msg && msg.details) {
            if (msg.details === 'ERROR' || msg.details === 'MessageValidationError' || msg.details === 'InvalidUserError' || msg.details === 'IllegalStateError' ) {
                dataForXc = { "msgId": "rg2xcErrorOccurred", "error": "genericError"};
            }

            if (msg.details === 'SystemError') {
                dataForXc = { "msgId": "rg2xcErrorOccurred", "error": "systemError"};
            };

            if (msg.details === 'TemporaryUnavailableError') {
                dataForXc = { "msgId": "rg2xcErrorOccurred", "error":"genericXCError", "details": "TemporaryUnavailableError"};
            };

            if (msg.details === 'InsufficientFundsError') {
                dataForXc = {"msgId":"rg2xcErrorOccurred", "error":"insufficientFundsError"}

                // START CODE BLOCK - for disable space or enter spin when PS popup is present
                const oldBtn1 = document.getElementById('focusBtn1');
                if (oldBtn1) {
                    oldBtn1.remove()
                }

                const newDiv1 = document.createElement("span");
                newDiv1.setAttribute("id", "focusBtn1");
                newDiv1.style.all = 'unset';
                const gameContainer1 = document.getElementById('gameContainer');

                if (gameContainer1) {
                    document.body.insertBefore(newDiv1, gameContainer1);

                    newDiv1.tabIndex = '-1';
                    newDiv1.focus();
                }
                // END CODE BLOCK
            };

            if (msg.details === 'RegulatoryError') {
                dataForXc = {"msgId":"rg2xcErrorOccurred", "error":"genericXCError", "details":"RegulatoryError"}

                // START CODE BLOCK - for disable space or enter spin when PS popup is present
                const oldBtn = document.getElementById('focusBtn');
                if (oldBtn) {
                    oldBtn.remove()
                }

                const newDiv = document.createElement("span");
                newDiv.setAttribute("id", "focusBtn");
                newDiv.style.all = 'unset';
                const gameContainer = document.getElementById('gameContainer');
                if (gameContainer) {
                    document.body.insertBefore(newDiv, gameContainer);

                    newDiv.tabIndex = '-1';
                    newDiv.focus();
                }
                // END CODE BLOCK
            };

            if (msg.details === 'SessionTerminatedError') {
                dataForXc = {"msgId":"rg2xcErrorOccurred", "error":"sessionExpiredError"}
            };

            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin && dataForXc !== undefined) {
                window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
            } else if (dataForXc !== undefined) {
                window.parent.postMessage(JSON.stringify(dataForXc), "*");
            };
        }
    }

    PLAYTECH_handler(msg) {
        try {
            //safety check
            msg = typeof msg === 'string' ? JSON.parse(msg) : msg;
        } catch (_) {}

        const type = msg?.type || "";
        const details = msg?.details || "";

        const nonFatalDetails = [
            "GAMING_LIMITS_REACHED",
            "GAME_UNAVAILABLE"
        ];

        if (type === "errorOutOfMoney" || details === "OUT_OF_MONEY") {
            return;
        }

        if (type === "error" && nonFatalDetails.includes(details)) {
            return;
        }

        const closeData = {
            _type: "ucip.basic.g2wCloseGameFrameCommand"
        };

        const doClose = () => {
            if (this.gb.settings.nativeMobileApp) {
                closeData.handled = true;
                window.parent.postMessage(JSON.stringify(closeData));
            } else {
                this.emitParent(JSON.stringify(closeData));
            }
        };

        setTimeout(doClose, 2000);

    }

    LNWOGS_handler(msg) {
        if (msg.data?.details === "GAMING_LIMITS_REACHED" || msg.data?.details === "OUT_OF_MONEY") {
            return; // Prevent the popup
        }
        this.gb.wallet.handleError(msg.details);
    }

    _default(msg) {
        this.emitTop({ wpgaction: "error", error: msg });
        this.emitParent({ wpgaction: "error.parent", error: msg });
        this.emitiOS({ wpgaction: "error", error: msg });
    }
}
